<template>
  <span :class="['action-menu-button', `action-menu-button--${type}`]">
    <i class="action-menu-button__icon"></i>
  </span>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .action-menu-button {
    display: inline-block;
    border: 1.3px solid $blue-grey-light;
    background-color: #fff;
    border-radius: 100%;
    width: 24px;
    height: 24px;

    &__icon {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center;
      mask-repeat: no-repeat;
      mask-position: center;
    }

    &:hover {
      border-color: $blue;
      cursor: pointer;
    }

    @each $type in ('config', 'connection', 'question', 'trash') {
      &--#{$type} {
        .action-menu-button__icon {
          background-image: url('/img/icons/pbx/action-controls/controls-#{$type}.svg');

          &:hover {
            background: $blue;
            mask-image: url('/img/icons/pbx/action-controls/controls-#{$type}.svg');
          }
        }
      }
    }
  }
</style>
